import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 2D8B2899-C765-48CF-9AEA-64327CB14542
 * name location-enter
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/location-enter.svg
 * tags
 * - Home Automation 
 */
export const LocationEnterIcon = createSvgIcon(<><path d="M14 12L10 8V11H2V13H10V16M22 12A10 10 0 0 1 2.46 15H4.59A8 8 0 1 0 4.59 9H2.46A10 10 0 0 1 22 12Z" /></>, 'LocationEnterIcon');
export default LocationEnterIcon